/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('CapacityServiceApi', ($http, ApiErrorService) => {
    return {
        getCapacitySimulatorInstanceDto: getCapacitySimulatorInstanceDto,
        isCapacitySim: isCapacitySim,
        syncSimulationData: syncSimulationData,
        getAvailableCapacityReportsForUser: getAvailableCapacityReportsForUser,
        getCapacityReport: getCapacityReport,
        getSessionHistory: getSessionHistory,
        run: run,
        pause: pause,
        clear: clear,
        updateTargetTPS: updateTargetTPS
    };
    function getCapacitySimulatorInstanceDto(userId, simulatorId) {
        return $http.get(`api/Capacity?userId=${userId}&simulatorId=${simulatorId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function isCapacitySim(simulatorId) {
        return $http.get(`api/Capacity/IsCapacitySim?simulatorId=${simulatorId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function syncSimulationData(userId, simulatorId) {
        return $http.post(`api/Capacity/SyncSimulationData?userId=${userId}&simulatorId=${simulatorId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAvailableCapacityReportsForUser() {
        return $http.get(`api/Capacity/Reports`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getCapacityReport(userId, simulatorId, reportId) {
        return $http.get(`api/Capacity/Reports/${userId}/${simulatorId}/${reportId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getSessionHistory(sessionId, limit) {
        return $http.get(`api/Capacity/${sessionId}/History?limit=${limit}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function run(sessionId, targetTps) {
        return $http.post(`api/Capacity/${sessionId}/Run?targetTps=${targetTps}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function pause(sessionId) {
        return $http.post(`api/Capacity/${sessionId}/Pause`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function clear(sessionId, userId) {
        return $http.post(`api/Capacity/${sessionId}/Delete?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function updateTargetTPS(sessionId, targetTps) {
        return $http.post(`api/Capacity/${sessionId}/TPS?targetTps=${targetTps}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
